import { IFilter } from '../../types/filters';
import { UrbanBathroomContainer } from '../../containers/advancedFilters/UrbanBathroomContainer';

export const urbanBathroom: IFilter = {
  component: UrbanBathroomContainer,
};
